/**
 *  InputLarge script file
**/

import { clickOutside } from '@/directives/click-outside'

export default {
  name: 'InputLarge',
  mixins: [],
  components: {},
  directives: {
    clickOutside
  },
  props: {
    type: {
      type: String,
      default: 'text'
    },
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: false
    },
    value: {
      type: [String, Number],
      required: false
    },
    defaultValue: {
      type: [String, Number],
      required: false
    },
    required: {
      type: Boolean,
      required: false
    },
    pattern: {
      type: RegExp,
      required: false
    },
    maxlength: {
      type: String,
      required: false
    },
    minlength: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    error: {
      type: String,
      required: false
    },
    showClearButton: {
      type: Boolean,
      default: false
    },
    validateThreshold: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      active: false,
      focus: false,
      fieldError: null
    }
  },
  mounted () {
    const val = this.value || this.defaultValue
    if (val) {
      this.$emit('input', val)
      this.active = true
    }
  },
  computed: {},
  methods: {
    onFocus () {
      this.focus = true
      this.active = true
      this.$refs.input.focus()
    },
    onBlur () {
      this.focus = false
      if (!this.value) {
        this.active = false
      }
    },
    clear () {
      this.$nextTick(() => {
        this.$emit('input', '')
        this.$refs.input.focus()
      })
    },
    getError () {
      if (this.error) {
        return this.error
      }

      const input = this.$refs.input
      if (!input) {
        return false
      }
      if (input.value && input.value.length < this.validateThreshold) {
        return false
      }
      if (input.validity.valueMissing) {
        return 'Campo obligatorio'
      }
      if (input.validity.badInput || input.validity.typeMismatch || input.validity.patternMismatch) {
        return 'Formato inválido'
      }
      if (input.validity.tooLong) {
        return `Este campo no debe contener mas de ${this.maxlength} caracteres`
      }
      if (input.validity.tooShort) {
        return `Este campo debe contener al menos ${this.minlength} caracteres`
      }
    }
  },
  watch: {
    value () {
      if (this.value !== this.$refs.input.value) {
        this.$refs.input.value = this.value
      }
      if (!this.active) {
        this.active = true
      }
      this.fieldError = this.getError()
    }
  }
}
